import { types } from 'mobx-state-tree';


export default types.model('ShippingMethod', {
	
	ShippingMethodId: types.number,
	DisplayName: types.string,
	Description: types.string,
    PriceFormatted: types.string,
    PriceWithTaxFormatted: types.string,
    ImageUrl: types.maybeNull(types.string)

}).views(self => ({
	get Order() {
		return getParent(self, 2);
	},

})).actions(self => ({
}));
